module.exports = __webpack_public_path__ + "img/plus-minus.6eb3c116.svg";